
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Corporatecabserviceinmumbai() {



    const cardData =
    {
        keyword: 'Corporate Cab Service in Mumbai',
        heading: 'S9 Travels: Corporate Cab Service in Mumbai',
        headingDescription: 'S9 Travels offers Corporate Cab Service in Mumbai, providing reliable, comfortable, and professional transportation for business executives, employees, and corporate events. Our well-maintained fleet, including sedans, SUVs, and luxury cabs, ensures a smooth and hassle-free travel experience. Enjoy on-time pickups, professional chauffeurs, affordable pricing, and 24/7 service for seamless corporate travel. Book your Corporate Cab Service in Mumbai with S9 Travels for a stress-free and efficient business commute!',


        top: 'Top Places to Visit in Mumbai with S9 Travels',

"topPlaces": [
    {
      "title": "Gateway of India",
      "description": "One of Mumbai’s most famous landmarks, the Gateway of India is a grand arch built in 1924 overlooking the Arabian Sea. It is a must-visit spot offering scenic views, ferry rides to Elephanta Caves, and a glimpse into Mumbai’s colonial past."
    },
    {
      "title": "Marine Drive",
      "description": "Also known as the 'Queen’s Necklace,' Marine Drive is a beautiful promenade along the Arabian Sea. It's a favorite spot for both locals and tourists to take a peaceful walk and enjoy breathtaking sunset views."
    },
    {
      "title": "Elephanta Caves",
      "description": "A UNESCO World Heritage Site, Elephanta Caves are located on Elephanta Island and feature rock-cut temples dedicated to Lord Shiva. The caves are famous for their ancient sculptures and stunning architecture."
    },
    {
      "title": "Chhatrapati Shivaji Maharaj Terminus",
      "description": "A UNESCO-listed historic railway station, this Victorian Gothic-style building is an architectural masterpiece. Built in 1887, it is a blend of Indian and British design elements and remains one of Mumbai’s busiest transport hubs."
    },
    {
      "title": "Siddhivinayak Temple",
      "description": "Dedicated to Lord Ganesha, Siddhivinayak Temple is one of Mumbai’s most revered temples. It attracts thousands of devotees daily, including Bollywood celebrities and politicians."
    },
    {
      "title": "Colaba Causeway",
      "description": "A bustling street market known for its vibrant shops, Colaba Causeway is a paradise for shoppers looking for trendy fashion, antiques, and souvenirs. The area is also home to popular cafes and restaurants."
    },
    {
      "title": "Juhu Beach",
      "description": "One of Mumbai’s most famous beaches, Juhu Beach is known for its street food stalls serving Mumbai’s iconic snacks like vada pav and pav bhaji. It’s a perfect place to relax by the sea and watch the sunset."
    },
    {
      "title": "Haji Ali Dargah",
      "description": "Located on a small islet off the Mumbai coast, Haji Ali Dargah is a stunning Indo-Islamic shrine dedicated to the Sufi saint Pir Haji Ali Shah Bukhari. It is connected to the city by a narrow causeway, making it a unique spiritual destination."
    },
    {
      "title": "Bandra-Worli Sea Link",
      "description": "An engineering marvel, the Bandra-Worli Sea Link is an eight-lane bridge connecting South Mumbai to the western suburbs. It offers stunning views of the Mumbai skyline, especially at night when it's beautifully lit up."
    },
    {
      "title": "Kanheri Caves",
      "description": "Located within Sanjay Gandhi National Park, the Kanheri Caves are ancient Buddhist rock-cut caves dating back to the 1st century BCE. They feature intricate carvings, stupas, and meditation halls, providing a glimpse into India’s Buddhist heritage."
    }
],

"services": [
  {
    "name": "Corporate Cab Service in Mumbai",
    "description": "S9 Travels offers reliable corporate cab services in Mumbai for business professionals. Whether you need a ride for business meetings, corporate events, or airport transfers, our cabs ensure timely and comfortable travel, making your professional journey smooth and stress-free."
  },
  {
    "name": "Book Corporate Cabs for Business Travel in Mumbai",
    "description": "Booking corporate cabs for business travel in Mumbai is simple with S9 Travels. Whether you're traveling to meetings, conferences, or client visits, our professional chauffeurs provide a comfortable, safe, and punctual ride. Experience hassle-free transport with flexible booking options tailored to your business needs."
  },
  {
    "name": "Affordable Corporate Cab Service in Mumbai",
    "description": "S9 Travels provides affordable corporate cab services in Mumbai, offering a perfect blend of quality and cost-efficiency. Whether you're a startup or a large corporation, our budget-friendly options ensure you get professional transport without exceeding your budget, all while enjoying comfort and reliability."
  },
  {
    "name": "Professional Corporate Transport Solutions in Mumbai",
    "description": "Need professional transport solutions for your business in Mumbai? S9 Travels offers comprehensive corporate transport services, ensuring your team travels efficiently to meetings, conferences, and business trips. Our fleet of well-maintained cars and experienced chauffeurs will meet all your business travel needs."
  },
  {
    "name": "Executive Cab Service for Business Meetings in Mumbai",
    "description": "Make the right impression with our executive cab service for business meetings in Mumbai. S9 Travels offers premium vehicles and professional drivers, ensuring you arrive at your meetings on time and in style. Our executive cabs are perfect for impressing clients or traveling to high-profile business engagements."
  },
  {
    "name": "Corporate Office Cab Booking in Mumbai",
    "description": "S9 Travels makes corporate office cab booking in Mumbai seamless and efficient. Whether you're booking daily commutes for employees or need transportation for an office event, our service ensures your team travels comfortably and promptly. Enjoy hassle-free cab booking with reliable service every time."
  },
  {
    "name": "Mumbai Corporate Event Taxi Service",
    "description": "S9 Travels offers dedicated corporate event taxi services in Mumbai. Whether it's a conference, seminar, or corporate retreat, our cabs provide timely and comfortable transport for your employees and guests, ensuring smooth logistics for your event. Let us handle the travel while you focus on the success of your event."
  },
  {
    "name": "Luxury Corporate Travel in Mumbai",
    "description": "For those looking for luxury corporate travel in Mumbai, S9 Travels offers top-tier vehicles equipped with premium amenities. Our luxury cabs are perfect for executives and clients, providing a comfortable and stylish ride for business meetings, events, and travel across the city."
  },
  {
    "name": "Group Travel for Business in Mumbai",
    "description": "S9 Travels provides group travel solutions for business in Mumbai. Whether it's for a corporate outing, seminar, or team-building event, our spacious vehicles can comfortably accommodate groups, ensuring a seamless and enjoyable journey. Book your corporate group travel with us and enjoy reliable transport for your team."
  }
],

"tableData": [
  ["Corporate Cab Service in Mumbai", "Book Corporate Cabs for Business Travel in Mumbai"],
  ["Affordable Corporate Cab Service in Mumbai", "Professional Corporate Transport Solutions in Mumbai"],
  ["Executive Cab Service for Business Meetings in Mumbai", "Corporate Office Cab Booking in Mumbai"],
  ["Mumbai Corporate Event Taxi Service", "Luxury Corporate Travel in Mumbai"],
  ["Group Travel for Business in Mumbai", ""],
  ["", ""]
],





"whychoose": [
  {
    "WhyChooseheading": "Comfortable and Professional Travel",
    "WhyChoosedescription": "S9 Travels offers a reliable corporate cab service in Mumbai, ensuring a comfortable and professional travel experience for your employees and clients. Our fleet includes well-maintained vehicles like sedans and SUVs, providing ample space, air conditioning, and plush seating."
  },
  {
    "WhyChooseheading": "Timely and Dependable Service",
    "WhyChoosedescription": "We understand the importance of punctuality in the corporate world. Our corporate cab service in Mumbai ensures timely pick-ups and drop-offs, allowing your team to stay on schedule and maintain a smooth workflow throughout the day."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our drivers are highly experienced and trained to provide a professional and courteous service. They are familiar with the best routes and traffic conditions in Mumbai, ensuring that your employees and clients have a safe, efficient, and smooth ride."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers competitive and transparent pricing for corporate cab services in Mumbai. We provide a clear breakdown of the cost upfront, with no hidden charges, allowing your company to plan travel expenses with ease."
  },
  {
    "WhyChooseheading": "Safety and Comfort for Corporate Travel",
    "WhyChoosedescription": "Your safety is our priority. All our corporate vehicles are equipped with modern safety features, including GPS tracking, airbags, and seat belts, ensuring a secure and comfortable ride for your team during business trips, meetings, and corporate events."
  },
  {
    "WhyChooseheading": "24/7 Availability for Flexible Scheduling",
    "WhyChoosedescription": "S9 Travels operates around the clock, offering flexible scheduling for your corporate cab needs in Mumbai. Whether you need transportation for early morning meetings or late-night events, we are available to meet your business travel requirements."
  },
  {
    "WhyChooseheading": "Customizable Corporate Travel Solutions",
    "WhyChoosedescription": "We understand that corporate travel often requires flexibility. Whether it’s multiple stops, specific time requirements, or unique travel arrangements, we offer customizable corporate travel solutions to meet your company’s needs."
  },
  {
    "WhyChooseheading": "Simple and Hassle-Free Booking",
    "WhyChoosedescription": "Booking your corporate cab service with S9 Travels is easy and hassle-free. You can book online through our website or mobile app, or contact our customer service team for personalized assistance, ensuring a smooth and efficient booking experience."
  }
]















    }

    const faqData = [
        [
          {
            question: 'How can I book a corporate cab service in Mumbai?',
            answer: 'Booking a corporate cab service in Mumbai is easy! You can make a reservation through our website, mobile app, or by contacting our customer service team. We offer quick and efficient booking to meet your business travel needs.',
          },
          {
            question: 'What types of vehicles are available for corporate cab service in Mumbai?',
            answer: 'We offer a range of vehicles for corporate cab services in Mumbai, including premium sedans, SUVs, and luxury vehicles. Choose a vehicle that suits the size of your group and your business requirements.',
          },
          {
            question: 'Are the drivers experienced for corporate cab services in Mumbai?',
            answer: 'Yes, our drivers are highly experienced, professional, and trained to provide excellent customer service. They are familiar with the best routes in Mumbai and ensure a safe and comfortable journey for your business trips.',
          },
          {
            question: 'Can I book a cab for multiple days for corporate travel in Mumbai?',
            answer: 'Yes, we offer flexible options for multiple-day bookings. Whether you need a cab for a full day or several days, we can accommodate your corporate travel needs in Mumbai.',
          },
          {
            question: 'How can I track my corporate cab during travel?',
            answer: 'You can track your corporate cab in real-time through our mobile app or website. Our system provides accurate updates on the vehicle’s location, ensuring you are informed about your journey at all times.',
          },
          {
            question: 'Is there a corporate discount for booking cabs in Mumbai?',
            answer: 'Yes, we offer special corporate discounts for regular or bulk bookings. Contact us for a customized quote based on your corporate needs and travel frequency.',
          },
          {
            question: 'Do you provide airport pick-up and drop-off services for corporate travel in Mumbai?',
            answer: 'Yes, we provide reliable airport pick-up and drop-off services for corporate travel. Whether arriving or departing from Chhatrapati Shivaji Maharaj International Airport (Mumbai Airport), we ensure timely and professional service.',
          },
          {
            question: 'Can I request additional services with the corporate cab booking in Mumbai?',
            answer: 'Yes, you can request additional services such as Wi-Fi, water bottles, or other amenities during your corporate cab booking in Mumbai. Simply let us know your preferences during the booking process.',
          },
          {
            question: 'Do you offer corporate cab services for long-distance trips from Mumbai?',
            answer: 'Yes, we offer corporate cab services for both local and long-distance trips from Mumbai. Whether it’s for a client meeting in nearby cities or an important event, we’ll ensure a comfortable and timely journey.',
          },
          {
            question: 'Why should I choose S9 Travels for my corporate cab service in Mumbai?',
            answer: 'S9 Travels offers reliable, professional, and comfortable corporate cab services in Mumbai. With well-maintained vehicles, experienced drivers, and excellent customer service, we ensure a smooth and efficient corporate travel experience.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Raghav Joshi',
          designation: 'Business Executive',
          rating: [1, 1, 1, 1, 1],
          text: '“We’ve been using S9 Travels for our corporate cab services in Mumbai, and the experience has been outstanding. The vehicles are always clean and well-maintained, and the drivers are professional and punctual. We’ve never had any issues, and their customer service is top-notch. Highly recommend them for business travel!”',
        },
        {
          name: 'Mrs. Shweta Kapoor',
          designation: 'Corporate Manager',
          rating: [1, 1, 1, 1, 1],
          text: '“S9 Travels has been our go-to service for corporate transportation in Mumbai. They offer reliable and punctual cab services, making our business trips stress-free. The drivers are courteous and professional, and the vehicles are always in great condition. I highly recommend S9 Travels for corporate travel needs!”',
        },
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   

      
     
    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Corporate Cab Service in Mumbai",
        "description": "Book affordable and professional corporate cab services in Mumbai for business travel, office commutes, executive meetings, and corporate events. S9 Travels offers reliable corporate transport solutions, luxury cabs, and group travel options in Mumbai.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "8569"
        }
      };
      
   
      


    return (
        <div>
        
        <Helmet>
        <title>Corporate Cab Service in Mumbai | Professional Business Travel | S9 Travels | Contact: +91 8850328441</title>
        <meta 
          name="description" 
          content="Book corporate cab services in Mumbai for business meetings, office commutes, and corporate events. Affordable and luxury transport solutions for professional travel, group business trips, and executive cabs with S9 Travels." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
      
      
<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/75.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Corporatecabserviceinmumbai;